<template>
  <div class="list">
    <div class="breadcrumb">
      <Breadcrumb>
        <Breadcrumb-item href="#">日常辅助</Breadcrumb-item>
        <Breadcrumb-item>消息模板</Breadcrumb-item>
      </Breadcrumb>
    </div>
    <div class="search" @keyup.enter="search">
      <Form :label-width="100" :show-message="false" label-position="right">
        <Row :gutter="32">
          <Col span="6">
            <Form-item label="模板名称">
              <Input placeholder="模糊搜素" name="params"
                     v-model="queryParam.params"></Input>
            </Form-item>
          </Col>
        </Row>
        <Row>
          <Col span="2">
            <Button type="primary" :loading="searchLoading" :disable="searchLoading" icon="search" @click="search">搜索</Button>
          </Col>
          <Col span="1">
            <Button type="primary" icon="plus" @click="showAddModal">新增</Button>
          </Col>
        </Row>
      </Form>
    </div>
    <List ref="dataList" :tableColumns="title" :reload="reload" listUrl="/activity/message-template"
          :params="queryParam" :onLoading="onLoading" operator=""></List>
    <!-- 新增消息模板模态框 -->
    <Modal
      v-model="addModalVisible"
      title="新增消息模板"
      :mask-closable="false"
      :width="600"
      @on-ok="handleAddConfirm"
      @on-cancel="addModalVisible = false">
      <Form :model="newTemplate" :label-width="100" ref="addTemplateForm">
        <FormItem label="模板名称:" prop="templateName">
          <Input v-model="newTemplate.templateName" placeholder="请输入模板名称" />
        </FormItem>
        <FormItem label="标题:" prop="title">
          <Input v-model="newTemplate.title" placeholder="请输入标题" />
        </FormItem>
        <FormItem label="模板内容:" prop="sendContent">
          <Input v-model="newTemplate.sendContent" type="textarea" :rows="4" placeholder="请输入模板内容" @keydown.enter.native.stop />
        </FormItem>
        <FormItem label="消息类型:" prop="msgType">
          <Select v-model="newTemplate.msgType" placeholder="请选择消息类型">
            <Option value="DING">钉钉消息</Option>
            <Option value="SMS">短信</Option>
            <Option value="EMAIL">邮件</Option>
            <Option value="CALL">电话</Option>
            <Option value="PUSH">推送</Option>
            <Option value="COMMON_WEB_HOOK">通用webhook</Option>
          </Select>
        </FormItem>
        <FormItem label="接收人:" prop="sendTo">
          <Select v-model="newTemplate.sendTo" placeholder="请选择接收人">
            <Option value="NONE">无身份</Option>
            <Option value="TCH">老师</Option>
            <Option value="STUDENT">学生</Option>
            <Option value="ADMIN">员工</Option>
            <Option value="WEB_HOOK">群机器人通知</Option>
          </Select>
        </FormItem>
        <FormItem label="AppId:" prop="dingAppId">
          <Input v-model="newTemplate.dingAppId" placeholder="请输入AppId" />
        </FormItem>
        <FormItem label="Secret:" prop="dingSecret">
          <Input v-model="newTemplate.dingSecret" type="password" placeholder="请输入Secret" />
        </FormItem>
        <FormItem label="WebHook:" prop="hookUrl">
          <Input v-model="newTemplate.hookUrl" placeholder="请输入WebHook地址" />
        </FormItem>
        <FormItem label="状态:" prop="enabled">
          <i-switch v-model="newTemplate.enabled" size="large">
            <span slot="open">正常</span>
            <span slot="close">禁用</span>
          </i-switch>
        </FormItem>
      </Form>
    </Modal>
  </div>
</template>
<script>

export default {
  components: {},
  data () {
    let $constant = this.$constant
    return {
      searchLoading: false,
      exportLoading: false,
      reload: 0,
      checkKeys: [],
      addModalVisible: false,
      newTemplate: {
        templateName: '',
        title: '',
        sendContent: '',
        msgType: '',
        sendTo: '',
        dingAppId: '',
        dingSecret: '',
        hookUrl: '',
        enabled: true
      },
      queryParam: {
        startTime: '',
        endTime: '',
        sysFrom: '',
      },
      statusList: $constant.enabledStatus,
      adminGroupList: null,
      departmentList: null,
      userList: null,
      title: [
        {
          title: '模板名称',
          align: 'center',
          width: 300,
          key: 'templateName',
          fixed: 'left',
        },
        {
          title: '标题',
          width: 300,
          align: 'center',
          render: (h, params) => {
            let row = params.row
            return h('Input', {
              props: {
                value: row.title,
              },
              on: {
                'on-blur': (event) => {
                  const newValue = event.target.value
                  if (newValue !== row.title) {
                    row.title = newValue
                    this.updateTchDirect({templateName: row.templateName, title: newValue})
                  }
                },
                'on-enter': (value) => {
                  if (value !== row.templateName) {
                    row.templateName = value
                    this.updateTchDirect({templateName: row.templateName, title: value})
                  }
                }
              }
            })
          }
        },
        {
          title: '模板内容',
          width: 400,
          align: 'center',
          render: (h, params) => {
            let row = params.row
            return h('Input', {
              attrs: {
                title: row.sendContent || '',  // 添加title属性显示完整内容
                rows: 5  // 默认显示3行
              },
              props: {
                value: row.sendContent,
                placeholder: 'remark',
                type: 'textarea'
              },
              style: {
                resize: 'vertical'  // 允许垂直方向调整大小
              },
              on: {
                'on-blur': (event) => {
                  const newValue = event.target.value
                  if (newValue !== row.sendContent) {
                    row.sendContent = newValue
                    this.updateTchDirect({templateName: row.templateName, sendContent: newValue})
                  }
                }
              }
            })
          }
        },
        {
          title: '消息类型',
          align: 'center',
          width: 150,
          key: 'msgTypeName'
        },
        {
          title: '接收人',
          width: 150,
          align: 'center',
          key: 'sendToName'
        },
        {
          title: 'AppId',
          width: 300,
          align: 'center',
          render: (h, params) => {
            let row = params.row
            return h('Input', {
              props: {
                value: row.dingAppId,
              },
              on: {
                'on-blur': (event) => {
                  const newValue = event.target.value
                  if (newValue !== row.dingAppId) {
                    row.dingAppId = newValue
                    this.updateTchDirect({templateName: row.templateName, dingAppId: newValue})
                  }
                },
                'on-enter': (value) => {
                  if (value !== row.dingAppId) {
                    row.dingAppId = value
                    this.updateTchDirect({templateName: row.templateName, dingAppId: value})
                  }
                }
              }
            })
          }
        },
        {
          title: 'Secret',
          width: 300,
          align: 'center',
          render: (h, params) => {
            let row = params.row
            return h('Input', {
              props: {
                value: row.dingSecret,
              },
              on: {
                'on-blur': (event) => {
                  const newValue = event.target.value
                  if (newValue !== row.dingSecret) {
                    row.dingSecret = newValue
                    this.updateTchDirect({templateName: row.templateName, dingSecret: newValue})
                  }
                },
                'on-enter': (value) => {
                  if (value !== row.dingSecret) {
                    row.dingSecret = value
                    this.updateTchDirect({templateName: row.templateName, dingSecret: value})
                  }
                }
              }
            })
          }
        },
        {
          title: 'WebHook',
          width: 300,
          align: 'center',
          render: (h, params) => {
            let row = params.row
            return h('Input', {
              props: {
                value: row.hookUrl,
              },
              on: {
                'on-blur': (event) => {
                  const newValue = event.target.value
                  if (newValue !== row.hookUrl) {
                    row.hookUrl = newValue
                    this.updateTchDirect({templateName: row.templateName, hookUrl: newValue})
                  }
                },
                'on-enter': (value) => {
                  if (value !== row.hookUrl) {
                    row.hookUrl = value
                    this.updateTchDirect({templateName: row.templateName, hookUrl: value})
                  }
                }
              }
            })
          }
        },
        {
          title: '最近更新时间',
          align: 'center',
          width: 180,
          key: 'updateTime'
        },
        {
          title: '操作',
          align: 'center',
          width: 80,
          render: (h, params) => {
            return h('div', [
              h('Button', {
                props: {
                  type: 'error',
                  size: 'small'
                },
                on: {
                  click: () => {
                    this.remove(params.row)
                  }
                }
              }, '删除')
            ])
          }
        },
        {
          title: '状态',
          width: 150,
          align: 'center',
          fixed: 'right',
          render: (h, params) => {
            let row = params.row
            let statusValue = row.enabled === 1

            return h('i-switch', {  // 使用 i-switch 而不是 Switch
              props: {
                value: statusValue,
                size: 'large'
              },
              on: {
                'input': (value) => {
                  row.enabled = value ? 1 : 0
                  this.updateTchDirect({templateName: row.templateName, enabled: value ? 1 : 0})
                }
              }
            }, [
              h('span', {slot: 'open'}, '正常'),
              h('span', {slot: 'close'}, '禁用')
            ])
          }
        },
      ]
    }
  },
  mounted: function () {
  },
  created: function () {
  },
  methods: {
    search () {
      this.reload = new Date().getTime()
    },
    onLoading (loading) {
      this.searchLoading = loading
    },
    atimeDateChange (value) {
      this.queryParam.startTime = value[0]
      this.queryParam.endTime = value[1]
      this.search()
    },
    updateTchDirect (req) {
      this.$http.post('/activity/message-template-update', req).then(res => {
        if (res.status === 'ok') {
          this.$Message.success('更新成功')
        } else {
          this.$Message.error(res.msg)
        }
      }).catch(() => {
        this.$Message.error('更新失败')
      })
    },
    showAddModal () {
      this.addModalVisible = true
      // 重置表单数据
      this.newTemplate = {
        templateName: '',
        title: '',
        sendContent: '',
        msgType: '',
        sendTo: '',
        dingAppId: '',
        dingSecret: '',
        hookUrl: '',
        enabled: true
      }
    },
    handleAddConfirm () {
      // 验证必填项
      if (!this.newTemplate.templateName) {
        this.$Message.error('请填写模板名称')
        return
      }

      if (!this.newTemplate.title) {
        this.$Message.error('请填写标题')
        return
      }

      // 调用API添加新模板
      const params = {
        templateName: this.newTemplate.templateName,
        title: this.newTemplate.title,
        sendContent: this.newTemplate.sendContent,
        msgType: this.newTemplate.msgType,
        sendTo: this.newTemplate.sendTo,
        dingAppId: this.newTemplate.dingAppId,
        dingSecret: this.newTemplate.dingSecret,
        hookUrl: this.newTemplate.hookUrl,
        enabled: this.newTemplate.enabled ? 1 : 0
      }

      this.$http.post('/activity/message-template-add', params).then(res => {
        if (res.status === 'ok') {
          this.$Message.success('新增成功')
          this.addModalVisible = false
          this.search() // 刷新列表
        } else {
          this.$Message.error(res.msg)
        }
      }).catch(() => {
        this.$Message.error('新增失败')
      })
    },
    remove (row) {
      this.$Modal.confirm({
        title: '确认删除',
        content: `确定要删除模板 "${row.templateName}" 吗？`,
        onOk: () => {
          this.$http.post('/activity/message-template-remove', {
            templateName: row.templateName
          }).then(res => {
            if (res.status === 'ok') {
              this.$Message.success('删除成功')
              this.search() // 刷新列表
            } else {
              this.$Message.error(res.msg)
            }
          }).catch(() => {
            this.$Message.error('删除失败')
          })
        }
      })
    }
  }
}

</script>

<style lang="less" scoped>
.btn-wrap {
  text-align: right;
  margin-top: 24px;
  margin-bottom: 12px;
}
</style>



// WEBPACK FOOTER //
// MessageTemplate.vue?213777e0